import { Component, Input, Output, OnChanges, SimpleChanges, SimpleChange, EventEmitter } from '@angular/core';
import { Observable, Subject } from 'rxjs/Rx';


@Component({
    selector: 'share-source-dialog',
	templateUrl: './share-source-dialog.component.html',
	styleUrls: ['./share-source-dialog.component.scss']
})
export class ShareSourceDialogComponent {

	@Input()
	public sharedItemGuid: string;

	@Input()
	public sourceUserGuid: string;

	@Input()
	public display: boolean;

	@Output()
	public displayChange: EventEmitter<any>;

	@Output()
	public onClose: EventEmitter<any>;

	constructor() {
		this.sharedItemGuid = "";
		this.sourceUserGuid = "";
		this.display = false;
		this.displayChange = new EventEmitter<any>();
		this.onClose = new EventEmitter<any>();
	}

	public ngOnChanges(changes: SimpleChanges): void {
		let change: SimpleChange = null;

		change = changes["display"];
		if (change) {
			if (this.display) {
			}
		}
	}

	public handleClose(): void {
		this.hideDialog();
		this.onClose.emit(true);
	}

	public onDialogHide(): void {
		this.handleClose();
	}

    public displayDialog() {
		this.display = true;
		this.displayChange.emit();
    }

    public hideDialog() {
        this.display = false;
		this.displayChange.emit();
    }

}
